module.exports = __webpack_public_path__ + "img/chakra-bracelet.3c88a0bb.jpg";